import React, { Component } from "react";
import { Redirect } from "react-router-dom"; //make sure to import all the components.
import "./project_search_table_row.scss";
import * as actionTypes from "../../store/actions";
import { connect } from "react-redux";
import ProjectSearchArchive from "./projectSearchArchive";
import CopyProject from "./projectCopy";
import Button from "@material-ui/core/Button";
import Axios from "axios";
import { toast } from "react-toastify";
import DialogStatus from "./DialogStatus";
import DialogNotes from "./DialogNotes";
import Translated from "../../components/Translated/Translated";
import translator from "../../utils/translator";

class project_search_table_row extends Component {
	state = {
		redirect: false
	};

	projectSetup = async projectId => {
		try {
			let redirectUrl =
				(this.props.isItActive ? "/project?projectId=" : "/project-summary/") +
				this.props.projectId;
			await this.props.saveAccountId(this.props.account);
			await this.props.saveProjectId(this.props.projectId); // we will use this to increase the quantity of a product for a SPECIFIC project
			let redirect = <Redirect to={redirectUrl} />;
			await this.setState({ redirect: redirect });
		} catch (error) {
			console.log(
				"here is the error message for setting the project id to redux ",
				error.message
			);
		}
	};

	activateProject = async event => {
		event.stopPropagation();
		let activateProjectAPIUrl = this.props.APIUrl + "/projects/activate-project";
		let data = {
			projectId: this.props.projectId
		};
		let activateProjectAPIResponse = await Axios.post(activateProjectAPIUrl, data);
		this.props.reRenderSearchResults();

		// For some reason it wont toast when activating a project
		toast.success(translator("Project Search", "activate_success"), {
			position: "bottom-center",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true
		});
	};

	render() {
		const status_labels = [
			translator("Misc", "lost_label"),
			translator("Misc", "won_label"),
			translator("Misc", "sent_label")
		];
		return (
			<React.Fragment>
				<tr class="project-search-table-row" onClick={this.projectSetup}>
					{this.state.redirect ? this.state.redirect : null}
					<th id="tbody-header" scope="row">
						{this.props.projectNumber}
					</th>
					<td>{this.props.projectId}</td>
					<td>{this.props.projectTitle}</td>
					<td>{this.props.account}</td>
					<td>{this.props.accountName}</td>
					<td>{this.props.shipTo}</td>
					<td>{this.props.warehouse}</td>
					<td>{this.props.teamMember}</td>
					<td>{this.props.dateCreated}</td>
					<td>${this.props.amount}</td>
					<DialogNotes
						projectId={this.props.projectId}
						notes={this.props.notes}
						re_render_project_search_results={
							this.props.reRenderProjectSearchResultsForCopyingAndArchiving
						}
					/>

					{this.props.isItActive ? (
						""
					) : (
						<>
							<DialogStatus
								label={status_labels[this.props.status]}
								message={
									this.props.archival_reason
										? this.props.archival_reason
										: translator("Misc", "archival_reason_default")
								}
							/>
							<td>
								{this.props.order !== null
									? this.props.order
									: translator("Misc", "not_available_label")}
							</td>
						</>
					)}
					{this.props.trendArchive === null ? ( 
						<>
							<td class="table-body-buttons">
							{this.props.isItActive ? (
								<ProjectSearchArchive
									projectId={this.props.projectId}
									reRenderSearchResults={this.props.reRenderSearchResults}
								/>
							) : (
								<Button
									variant="outlined"
									color="primary"
									onClick={this.activateProject}
								>
									<Translated section="Misc" label="activate_label" />
								</Button>
							)}
						</td>
						<td class="table-body-buttons">
							<CopyProject
								projectId={this.props.projectId}
								reRenderProjectSearchResultsForCopyingAndArchiving={
									this.props.reRenderProjectSearchResultsForCopyingAndArchiving
								}
								reRenderSearchResults={this.props.reRenderSearchResults}
								isItActive={this.props.isItActive}
							/>
						</td>
						</>
					) : <><td class="table-body-buttons"></td><td class="table-body-buttons"></td></> }
				</tr>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => ({
	projectIdFromRedux: state.projectIdUsedToIncreaseProductQuantity,
	APIUrl: state.APIUrl
});

const mapDispatchToProps = dispatch => {
	return {
		saveAccountId: accountId =>
			dispatch({
				type: actionTypes.SAVE_ACCOUNT_ID_FOR_GETTING_PRODUCT_INFORMATION_LATER,
				accountId: accountId
			}),
		saveProjectId: projectId =>
			dispatch({
				type: actionTypes.SAVE_PROJECT_ID_TO_INCREASE_THE_QUANTITY_OF_A_PRODUCT,
				projectId: projectId
			})
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(project_search_table_row);
